import {
  SActionWrapper,
  SCenteredTextImageSection,
  SDetails,
  SImageContainer,
  STitle,
} from './CenteredTextImageSection.styled'
import { Title_h3_default } from 'components/Typography'
import { ReactElement, ReactNode } from 'react'
import { HorizontalPlacement } from 'utils/types'

interface Props {
  title?: string | null
  image?: ReactElement
  children?: ReactNode
  imagePlacement?: HorizontalPlacement
  action?: ReactNode
}

export const CenteredTextImageSection = (props: Props) => {
  return (
    <SCenteredTextImageSection imagePlacement={props.imagePlacement}>
      <SImageContainer imagePlacement={props.imagePlacement}>{props.image}</SImageContainer>
      <STitle variant={Title_h3_default}>{props.title}</STitle>
      <SDetails>{props.children}</SDetails>
      <SActionWrapper>{props.action}</SActionWrapper>
    </SCenteredTextImageSection>
  )
}
